import { createFlashMessage } from '@components/Flash/redux';
import { call, put, takeLatest } from 'redux-saga/effects';
import { completeNacionalUser } from '../utils/ajax';
import { actionTypes } from './action-types';

function* completeNacionalRegister(action) {
  try {
    yield call(completeNacionalUser, action.payload);
    yield put({ type: actionTypes.fetchUser });
  } catch (e) {
    console.log('completeNacionalRegister error', e);
    createFlashMessage({
      type: 'danger',
      message: 'Erro ao atualizar o registro nacional.',
      variables: { dismissible: true }
    });
  }
}

export function createNacionalSaga(types) {
  return [takeLatest(types.completeNacionalRegister, completeNacionalRegister)];
}
